import React, { useState, useEffect, useRef } from "react";
import api from "../api/api";
import Attachments from "../UserControls/Attachments/Attachments";
import Header from "./Header";


export default function ItemsPage() {
  const [activeCategory, setActiveCategory] = useState("");
  const [selectedItems, setSelectedItems] = useState([]);
  const [table1Items, setTable1Items] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(-1);
  const [updatedRows, setUpdatedRows] = useState([]);
  const [itemsData, setItemsData] = useState({});
  const [categories, setCategories] = useState([]);
  const dropdownRef = useRef(null);
  const listRef = useRef(null);
  const previousMenuRef = useRef(null);
  const [description, setDescription] = useState("");
  const [rateEdit, setRateEdit] = useState(false);
  const [showAreaPopup, setShowAreaPopup] = useState(false);
  const [areaLoading, setAreaLoading] = useState(false);
  const [areaCircles, setAreaCircles] = useState([]);
  const [areaRows, setAreaRows] = useState([]);
  const [activeAreaCircle, setActiveAreaCircle] = useState("");
  const [areaSearchText, setAreaSearchText] = useState("");
  const [areaLockLists, setAreaLockLists] = useState([]);
  const [areaLockListDetails, setAreaLockListDetails] = useState([]);
  const [selectedAreaLockList, setSelectedAreaLockList] = useState("");
  const [areaLockDropdownOpen, setAreaLockDropdownOpen] = useState(false);
  const [listSaveLoading, setListSaveLoading] = useState(false);
  const [areaPopupDate, setAreaPopupDate] = useState("");
  const [selectedAreaIdsByDate, setSelectedAreaIdsByDate] = useState({});
  const [showPreviousMenuPicker, setShowPreviousMenuPicker] = useState(false);
  const [previousMenuDate, setPreviousMenuDate] = useState("");
  const [previousMenuLoading, setPreviousMenuLoading] = useState(false);
  const [previousMenuInsertLoading, setPreviousMenuInsertLoading] = useState(false);
  const [showPreviousMenuPopup, setShowPreviousMenuPopup] = useState(false);
  const [previousMenuRows, setPreviousMenuRows] = useState([]);



  const [showTimePopup, setShowTimePopup] = useState(false);
  const [mealTimes, setMealTimes] = useState({
    breakfast: "",
    lunch: "",
    dinner: "",
    other: "",
  });

  const circles = ["Circle1", "Circle2", "Circle3"];
  const [selectedItem, setSelectedItem] = useState(null);
  const username = sessionStorage.getItem("username") || "UnknownUser";

  const today = new Date();
  const tomorrow = new Date();
  tomorrow.setDate(today.getDate() + 1);

  const formatDateForApi = (date) => date.toISOString().split("T")[0];
  const formatMenuDateForPost = (dateValue) => `${dateValue}T00:00:00+05:30`;
  const normalizeItemType = (itemType) => (itemType || "").toUpperCase();
  const getAreaLockKey = (dateValue, itemType = activeCategory) =>
    `${dateValue}_${itemType || "All"}`;
  const formatDisplayDate = (date) =>
    date.toLocaleDateString("en-GB", {
      weekday: "short",
      day: "2-digit",
      month: "short",
    });

  const [selectedDate, setSelectedDate] = useState(formatDateForApi(today));

  // ✅ Fetch Dashboard List (binds category buttons)
  const fetchDashboardList = async () => {
    try {
      const res = await api.get("GetDashboardListAPI", { user: username });
      const apiData = res?.data?.GetDashboardListjs || res?.GetDashboardListjs;
      const table1Data = apiData?.Table1 || [];

      if (!Array.isArray(table1Data) || table1Data.length === 0) {
        console.warn("⚠️ No Table1 data found in GetDashboardListAPI");
        setCategories([]);
        return;
      }

      const extracted = table1Data
        .map((item) =>
          item?.Item_Type || item?.item_type || item?.ITEM_TYPE || null
        )
        .filter(Boolean);

      const uniqueCategories = [...new Set(extracted)];
      setCategories(uniqueCategories);

      if (!activeCategory && uniqueCategories.length > 0) {
        setActiveCategory(uniqueCategories[0]);
      }
    } catch (error) {
      console.error("❌ Error fetching dashboard list:", error);
    }
  };

  // ✅ Fetch Menu List when category or date changes
  const fetchMenuList = async (category) => {
    if (!category) return;
    try {
      const response = await api.get("GetMenulist", {
        user: username,
        ItemType: category,
        Menudate: selectedDate,
      });

      const apiData = response?.data?.GetMenulistjs || response?.GetMenulistjs;
      const menuList = apiData?.Table || [];
      const table1 = apiData?.Table1 || [];
      const table2 = apiData?.Table2 || [];

      setItemsData((prev) => ({ ...prev, [category]: menuList }));
      setSelectedItem(menuList[0] || null);

      const table1WithRates = table1.map((item) => {
        const savedDescription = localStorage.getItem(`item_desc_${item.ItemId}_${selectedDate}`);
        const itemDescription = savedDescription || item.Item_Desc2 || "";

        return {
        ...item,
         Item_Desc2: itemDescription === "''" ? "" : itemDescription,
        Menudate: item.Menudate?.split("T")[0] || formatDateForApi(today),
        rates: [
          Number(item.Circle1Rate || 0),
          Number(item.Circle2Rate || 0),
          Number(item.Circle3Rate || 0),
        ],
        TakeAway: Number(item.TakeAway || 0),
      };
      });

      setTable1Items(table1WithRates);

      const lockedAreaIds = table2
        .filter((row) => Number(row.IsAvail) === 0)
        .map((row) => String(row.AreaId));
      setSelectedAreaIdsByDate((prev) => ({
        ...prev,
        [getAreaLockKey(selectedDate, category)]: lockedAreaIds,
      }));
    } catch (error) {
      console.error("❌ Error fetching menu list:", error);
      alert("Failed to fetch menu list");
    }
  };

  const handlePreviousMenuDateChange = async (dateValue) => {
    setPreviousMenuDate(dateValue);
    if (!dateValue) return;

    setPreviousMenuLoading(true);
    try {
      const res =
        (await api.GetPreviousMenuListAPI?.(username, dateValue)) ||
        (await api.get("GetPreviousMenuListAPI", {
          Username: username,
          ActionDate: dateValue,
        }));
      const apiData =
        res?.data?.GetPreviousMenuListAPIjs ||
        res?.GetPreviousMenuListAPIjs ||
        {};
      const previousRows = Array.isArray(apiData.Table) ? apiData.Table : [];

      setPreviousMenuRows(previousRows);
      setShowPreviousMenuPicker(false);
      setShowPreviousMenuPopup(true);

      if (previousRows.length === 0) {
        alert("No previous menu items found for the selected date.");
      }
    } catch (error) {
      console.error("Error fetching previous menu:", error);
      alert("Failed to fetch previous menu list");
    } finally {
      setPreviousMenuLoading(false);
    }
  };

  const closePreviousMenuPopup = () => {
    setShowPreviousMenuPopup(false);
  };

  const handleInsertPreviousMenu = async () => {
    if (!previousMenuDate) {
      alert("Please select a previous menu date.");
      return;
    }

    setPreviousMenuInsertLoading(true);
    try {
      const payload = {
        Username: username,
        ActionDate: formatMenuDateForPost(previousMenuDate),
        MenuDate: formatMenuDateForPost(selectedDate),
      };

      await api.InsertPreviousMenuListAPI(payload);
      alert("Previous menu inserted successfully.");
      setShowPreviousMenuPopup(false);

      if (activeCategory) {
        fetchMenuList(activeCategory);
      }
    } catch (error) {
      console.error("Error inserting previous menu:", error);
      alert("Failed to insert previous menu list");
    } finally {
      setPreviousMenuInsertLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboardList();
  }, []);

  useEffect(() => {
    if (activeCategory) fetchMenuList(activeCategory);
  }, [activeCategory, selectedDate]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
        setActiveIndex(-1);
      }

      if (
        previousMenuRef.current &&
        !previousMenuRef.current.contains(event.target)
      ) {
        setShowPreviousMenuPicker(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key !== "Escape") return;

      setShowPreviousMenuPicker(false);
      setShowPreviousMenuPopup(false);
    };

    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, []);

  // Auto scroll for item dropdown
  useEffect(() => {
    if (listRef.current && activeIndex >= 0) {
      const item = listRef.current.children[activeIndex];
      item?.scrollIntoView({ block: "nearest" });
    }
  }, [activeIndex]);

  // ✅ Fetch meal times from API
  const fetchMealTimes = async () => {
    try {
      const res = await api.get("GetOrderTime", { Username: username });
      const apiData = res?.data?.GetOrderTimejs || res?.GetOrderTimejs;
      const table = apiData?.Table || [];

      if (table.length > 0) {
        const record = table[0];
        setMealTimes({
          breakfast: record.Breakfast || "",
          lunch: record.Lunch || "",
          dinner: record.Dinner || "",
          other: record.Other || "",
        });
      } else {
        console.warn("⚠️ No meal time data found in GetOrderTime API");
      }
    } catch (error) {
      console.error("❌ Error fetching meal times:", error);
    }
  };

  useEffect(() => {
    fetchMealTimes();
  }, []);

  useEffect(() => {
    if (!showAreaPopup) return;

    const handleEscClose = (event) => {
      if (event.key === "Escape") closeAreaPopup();
    };

    document.addEventListener("keydown", handleEscClose);
    return () => document.removeEventListener("keydown", handleEscClose);
  }, [showAreaPopup]);

  const filteredItems = (itemsData[activeCategory] || []).filter(
    (item) =>
      item.Item_Desc1?.toLowerCase().includes(searchText.toLowerCase()) ||
      item.Item_No?.toLowerCase().includes(searchText.toLowerCase())
  );

  const handleAddItem = async () => {
    if (
      !selectedItem ||
      !searchText.trim() ||
      !filteredItems.some((i) => i.Item_No === selectedItem.Item_No)
    ) {
      alert("Please select an item before adding!");
      return;
    }

    const isDuplicate =
      selectedItems.some((item) => item.Item_No === selectedItem.Item_No) ||
      table1Items.some((item) => item.Item_No === selectedItem.Item_No);

    if (isDuplicate) {
      alert("Item already added!");
      return;
    }

    const payload = {
      Items: [
        {
          ItemId: Number(selectedItem.ItemId || 0),
          Item_No: selectedItem.Item_No,
          Item_Desc1: selectedItem.Item_Desc1,

          Item_Desc2: description,
          Item_Type: selectedItem.Item_Type || activeCategory.toLowerCase(),

          StandardCost: Number(selectedItem.Circle1Rate || 0),
          MRP: Number(selectedItem.Circle1Rate || 0),
          Circle1Rate: Number(selectedItem.Circle1Rate || 0),
          Circle2Rate: Number(selectedItem.Circle2Rate || 0),
          Circle3Rate: Number(selectedItem.Circle3Rate || 0),
          DCApply: Number(selectedItem.DCApply || 10),
          TakeAway: Number(selectedItem.TakeAway || 0),
        },
      ],
      Menudate: selectedDate,
      User: username,
    };

    try {
      const res = await api.post("SaveMenuListAPI", payload);
      const savedItemId =
        res?.data?.SaveMenuList?.Table?.[0]?.ItemId ||
        res?.SaveMenuList?.Table?.[0]?.ItemId ||
        selectedItem.ItemId ||
        0;

      setTable1Items((prev) => [
        ...prev,
        {
          ...selectedItem,
          ItemId: savedItemId,
          Item_Desc2: description,
          Menudate: selectedDate,
          rates: [
            Number(selectedItem.Circle1Rate || 0),
            Number(selectedItem.Circle2Rate || 0),
            Number(selectedItem.Circle3Rate || 0),
          ],
          TakeAway: Number(selectedItem.TakeAway || 0),
          source: "table1",
        },
      ]);

      localStorage.setItem(`item_desc_${savedItemId}_${selectedDate}`, description);

      setSearchText("");
      setSelectedItem(null);
      setDescription("");
    } catch (error) {
      console.error("❌ Error adding item:", error);
      alert("Failed to add item. Check console for details.");
    }
  };

  const handleDelete = async (index, table = "table1") => {
    try {
      const item =
        table === "selected" ? selectedItems[index] : table1Items[index];
      const ItemId = item.ItemId || 0;
      const Menudate = item.Menudate || selectedDate;

      await api.get("DeleteOrderItemAPI", {
        ItemId,
        Menudate,
        User: username,
      });

      if (table === "selected") {
        setSelectedItems((prev) => prev.filter((_, i) => i !== index));
      } else {
        setTable1Items((prev) => prev.filter((_, i) => i !== index));
      }

      alert(`${item.Item_Desc1 || item.name} deleted successfully!`);
    } catch (error) {
      console.error("❌ Error deleting item:", error);
      alert("Failed to delete item. Check console for details.");
    }
  };

  const handleRateChange = (index, circleIndex, value, table = "selected") => {
    const updateList = table === "selected" ? selectedItems : table1Items;
    const setList = table === "selected" ? setSelectedItems : setTable1Items;

    setList(
      updateList.map((item, i) => {
        if (i === index) {
          const newRates = [...item.rates];
          newRates[circleIndex] = Number(value);
          return { ...item, rates: newRates };
        }
        return item;
      })
    );

    setUpdatedRows((prev) => (prev.includes(index) ? prev : [...prev, index]));
  };

  const handleTakeAwayChange = (index, value, table = "selected") => {
    const updateList = table === "selected" ? selectedItems : table1Items;
    const setList = table === "selected" ? setSelectedItems : setTable1Items;

    setList(
      updateList.map((item, i) =>
        i === index ? { ...item, TakeAway: Number(value) } : item
      )
    );

    setUpdatedRows((prev) => (prev.includes(index) ? prev : [...prev, index]));
  };

  const handleDescriptionChange = (index, value, table = "selected") => {
    const updateList = table === "selected" ? selectedItems : table1Items;
    const setList = table === "selected" ? setSelectedItems : setTable1Items;

    setList(
      updateList.map((item, i) =>
        i === index ? { ...item, Item_Desc2: value } : item
      )
    );

    setUpdatedRows((prev) => (prev.includes(index) ? prev : [...prev, index]));
  };

  const handleRowUpdate = async (index, table = "selected") => {
    try {
      const updatedItem =
        table === "selected" ? selectedItems[index] : table1Items[index];
      const user = username;
      const ItemId = updatedItem.ItemId || 0;
      const Menudate = updatedItem.Menudate || selectedDate;
      const [Circle1Rate, Circle2Rate, Circle3Rate] = updatedItem.rates || [
        0, 0, 0,
      ];
      const ItemDesc =
        updatedItem.Item_Desc2 && updatedItem.Item_Desc2 !== "''"
          ? updatedItem.Item_Desc2
          : "-";

      await api.get("RateUpdateAPI", {
        user,
        ItemId,
        Circle1Rate,
        Circle2Rate,
        Circle3Rate,
        TakeAway: Number(updatedItem.TakeAway || 0),
        ItemDesc,
        Menudate,
      });

      localStorage.setItem(`item_desc_${ItemId}_${selectedDate}`, ItemDesc);

      alert(
        `${updatedItem.Item_Desc1 || updatedItem.name} updated successfully!`
      );
      setUpdatedRows((prev) => prev.filter((i) => i !== index));
    } catch (error) {
      console.error("Error updating rate:", error);
      alert("Failed to update rate. Check console for details.");
    }
  };

  const handleBack = () => window.history.back();

  const handleLogout = () => {
    sessionStorage.removeItem("isLoggedIn");
    sessionStorage.removeItem("username");
    sessionStorage.removeItem("lastVisited");
    window.location.href = "/";
  };

  const displayItems = [
    ...selectedItems
      .map((item, sourceIndex) => ({
        ...item,
        source: "selected",
        sourceIndex,
        rates: item.rates || [0, 0, 0],
        TakeAway: Number(item.TakeAway || 0),
      }))
      .filter((item) => item.Menudate === selectedDate),
    ...table1Items
      .map((item, sourceIndex) => ({
        ...item,
        source: "table1",
        sourceIndex,
        rates: item.rates || [0, 0, 0],
        TakeAway: Number(item.TakeAway || 0),
      }))
      .filter((item) => item.Menudate === selectedDate),
  ];

  const openTimePopup = () => setShowTimePopup(true);
  const closeTimePopup = () => setShowTimePopup(false);

  const areaLockKey = getAreaLockKey(areaPopupDate);
  const selectedAreaIds = selectedAreaIdsByDate[areaLockKey] || [];
  const isRegularAreaLockList =
    selectedAreaLockList.trim().toLowerCase() === "regular";
  const filteredAreaLockLists = areaLockLists.filter((list) =>
    (list.ListName || "")
      .toLowerCase()
      .includes(selectedAreaLockList.trim().toLowerCase())
  );
  const selectedAreaIdSet = new Set(selectedAreaIds.map(String));
  const groupedAreaRows = areaRows.reduce((acc, row) => {
    const circleName = row.R1Name || "Others";
    if (!acc[circleName]) acc[circleName] = [];
    acc[circleName].push(row);
    return acc;
  }, {});
  const visibleAreaRows = groupedAreaRows[activeAreaCircle] || [];
  const getCircleLockedCount = (circleName) =>
    (groupedAreaRows[circleName] || []).filter((row) =>
      selectedAreaIdSet.has(String(row.AreaId))
    ).length;
  const filteredAreaRows = visibleAreaRows.filter((row) => {
    const search = areaSearchText.trim().toLowerCase();
    if (!search) return true;
    return (
      row.Area?.toLowerCase().includes(search) ||
      String(row.AreaId || "").includes(search) ||
      row.R1Name?.toLowerCase().includes(search)
    );
  });
  const allVisibleSelected =
    filteredAreaRows.length > 0 &&
    filteredAreaRows.every((row) => selectedAreaIdSet.has(String(row.AreaId)));

  const fetchAreaListCircleWise = async () => {
    setAreaLoading(true);
    try {
      const res =
        (await api.GetAreaListCircleWiseAPI?.(username)) ||
        (await api.get("GetAreaListCircleWiseAPI", { Username: username }));
      const apiData =
        res?.data?.GetAreaListCircleWiseAPIjs ||
        res?.GetAreaListCircleWiseAPIjs ||
        {};
      const circlesData = Array.isArray(apiData.Table) ? apiData.Table : [];
      const rowsData = Array.isArray(apiData.Table1) ? apiData.Table1 : [];
      const circleNames = circlesData
        .map((circle) => circle.R1Name)
        .filter(Boolean);
      const fallbackCircleNames = [
        ...new Set(rowsData.map((row) => row.R1Name).filter(Boolean)),
      ];
      const nextCircles = circleNames.length ? circleNames : fallbackCircleNames;

      setAreaCircles(nextCircles);
      setAreaRows(rowsData);
      setActiveAreaCircle((prev) => prev || nextCircles[0] || "");
    } catch (error) {
      console.error("Error fetching circle wise area list:", error);
      alert("Failed to fetch area list");
    } finally {
      setAreaLoading(false);
    }
  };

  const fetchAreaLockLists = async () => {
    try {
      const res =
        (await api.GetSavedAreaLockListAPI?.(username)) ||
        (await api.get("GetSavedAreaLockListAPI", { Username: username }));
      const apiData = res?.data || res || {};

      setAreaLockLists(Array.isArray(apiData.Table) ? apiData.Table : []);
      setAreaLockListDetails(
        Array.isArray(apiData.Table1) ? apiData.Table1 : []
      );
    } catch (error) {
      console.error("Error fetching area lock lists:", error);
      setAreaLockLists([]);
      setAreaLockListDetails([]);
    }
  };

  const handleAreaLockListChange = (listName) => {
    setSelectedAreaLockList(listName);

    const normalizedListName = listName.trim();

    if (!normalizedListName) {
      setSelectedAreaIdsByDate((prev) => ({
        ...prev,
        [areaLockKey]: [],
      }));
      return;
    }

    const selectedList = areaLockListDetails.find(
      (list) =>
        list.ListName?.toLowerCase() === normalizedListName.toLowerCase() &&
        normalizeItemType(list.ItemType) === normalizeItemType(activeCategory)
    );
    const selectedIds = String(selectedList?.AreaIds || "")
      .split(",")
      .map((id) => id.trim())
      .filter((id) => id && id !== "0");
    const validAreaIds = new Set(areaRows.map((row) => String(row.AreaId)));
    const matchedAreaIds = selectedIds.filter((id) => validAreaIds.has(id));

    setSelectedAreaIdsByDate((prev) => ({
      ...prev,
      [areaLockKey]: matchedAreaIds,
    }));
  };

  const openAreaPopup = async (dateValue) => {
    setSelectedDate(dateValue);
    setAreaPopupDate(dateValue);
    setSelectedAreaLockList("");
    setShowAreaPopup(true);
    if (areaCircles.length === 0 && areaRows.length === 0) {
      await fetchAreaListCircleWise();
    }
    if (areaLockLists.length === 0 && areaLockListDetails.length === 0) {
      await fetchAreaLockLists();
    }
  };

  const closeAreaPopup = () => {
    setShowAreaPopup(false);
    setAreaPopupDate("");
    setAreaSearchText("");
    setSelectedAreaLockList("");
    setAreaLockDropdownOpen(false);
  };

  const toggleArea = (areaId, checked) => {
    setSelectedAreaIdsByDate((prev) => {
      const existing = new Set((prev[areaLockKey] || []).map(String));
      if (checked) {
        existing.add(String(areaId));
      } else {
        existing.delete(String(areaId));
      }
      return { ...prev, [areaLockKey]: Array.from(existing) };
    });
  };

  const toggleCircleAreas = (checked) => {
    setSelectedAreaIdsByDate((prev) => {
      const existing = new Set((prev[areaLockKey] || []).map(String));
      filteredAreaRows.forEach((row) => {
        if (checked) {
          existing.add(String(row.AreaId));
        } else {
          existing.delete(String(row.AreaId));
        }
      });
      return { ...prev, [areaLockKey]: Array.from(existing) };
    });
  };

  const getSelectedAreaRows = () =>
    areaRows.filter((row) => selectedAreaIdSet.has(String(row.AreaId)));

  const buildAreaLockPayload = (selectedRows) => ({
    Username: username,
    ListName: selectedAreaLockList,
    ItemType: activeCategory,
    AreaIds: selectedRows.map((row) => ({
      AreaId: Number(row.AreaId),
    })),
  });

  const handleDistributionListSave = async () => {
    if (!selectedAreaLockList) {
      alert("Please select an area lock list first.");
      return;
    }

    if (isRegularAreaLockList) {
      alert("Regular list cannot be updated.");
      return;
    }

    const selectedRows = getSelectedAreaRows();

    if (selectedRows.length === 0) {
      alert("Please select at least one area to save in the list.");
      return;
    }

    const payload = buildAreaLockPayload(selectedRows);

    try {
      setListSaveLoading(true);
      const res = await api.UpdateDistributionListAPI(payload);
      const result =
        res?.data?.UpdateDistributionListAPIjs?.Table?.[0] ||
        res?.UpdateDistributionListAPIjs?.Table?.[0] ||
        res?.data?.Table?.[0] ||
        res?.Table?.[0] ||
        {};

      const areaIdsText = selectedRows.map((row) => row.AreaId).join(",");
      setAreaLockLists((prev) => {
        const exists = prev.some(
          (list) =>
            list.ListName?.toLowerCase() ===
            selectedAreaLockList.trim().toLowerCase()
        );
        return exists
          ? prev
          : [...prev, { ListName: selectedAreaLockList.trim() }];
      });
      setAreaLockListDetails((prev) => {
        const isCurrentListRow = (list) =>
          list.ListName === selectedAreaLockList &&
          normalizeItemType(list.ItemType) === normalizeItemType(activeCategory);
        const exists = prev.some(isCurrentListRow);
        if (!exists) {
          return [
            ...prev,
            {
              ListName: selectedAreaLockList,
              AreaIds: areaIdsText,
              ItemType: normalizeItemType(activeCategory),
            },
          ];
        }
        return prev.map((list) =>
          isCurrentListRow(list)
            ? { ...list, AreaIds: areaIdsText }
            : list
        );
      });

      alert(result.Message || "Area lock list saved successfully!");
    } catch (error) {
      console.error("Error saving area lock list:", error);
      alert("Failed to save area lock list.");
    } finally {
      setListSaveLoading(false);
    }
  };

  const handleAreaSave = async () => {
    const selectedRows = getSelectedAreaRows();

    if (selectedRows.length === 0) {
      alert("Please select at least one area to lock.");
      return;
    }

    const payload = {
      Username: username,
      MenuDate: formatMenuDateForPost(areaPopupDate),
      ItemType: activeCategory,
      AreaIds: selectedRows.map((row) => ({
        AreaId: Number(row.AreaId),
      })),
    };

    try {
      const res = await api.UpdateRainDisabledAreasAPI(payload);
      const result =
        res?.data?.UpdateRainDisabledAreasAPIjs?.Table?.[0] ||
        res?.UpdateRainDisabledAreasAPIjs?.Table?.[0] ||
        {};

      if (Number(result.Status || 0) !== 1) {
        alert(result.Message || "Failed to save no supply areas.");
        return;
      }

      alert(result.Message || "No supply areas saved successfully!");
      setSelectedAreaIdsByDate((prev) => ({
        ...prev,
        [areaLockKey]: selectedRows.map((row) => String(row.AreaId)),
      }));
      closeAreaPopup();
    } catch (error) {
      console.error("Error saving no supply areas:", error);
      alert("Failed to save no supply areas.");
    }
  };

  const handleTimeChange = (field, value) => {
    setMealTimes((prev) => ({ ...prev, [field]: value }));
  };

  const preventScroll = (e) => {
  e.preventDefault();
};

const handleFocusAddWheelBlock = (ev) => {
  // non-passive so preventDefault() works
  ev.target.addEventListener("wheel", preventScroll, { passive: false });
};

const handleBlurRemoveWheelBlock = (ev) => {
  ev.target.removeEventListener("wheel", preventScroll, { passive: false });
};

const handleKeyDownItem = (e) => {
  const options = filteredItems;
  if (!dropdownOpen && (e.key === "ArrowDown" || e.key === "ArrowUp")) {
    setDropdownOpen(true);
    setActiveIndex(0);
    return;
  }

  switch (e.key) {
    case "ArrowDown":
      e.preventDefault();
      setActiveIndex(i => i < options.length - 1 ? i + 1 : 0);
      break;
    case "ArrowUp":
      e.preventDefault();
      setActiveIndex(i => i > 0 ? i - 1 : options.length - 1);
      break;
    case "Enter":
      if (dropdownOpen && activeIndex >= 0) {
        e.preventDefault();
        const selected = options[activeIndex];
        if (selected) {
          setSelectedItem(selected);
          setSearchText(selected.Item_Desc1);
          setDropdownOpen(false);
          setActiveIndex(-1);
        }
      }
      break;
    case "Escape":
      setDropdownOpen(false);
      setActiveIndex(-1);
      break;
    default:
      break;
  }
};

  const handleTimeSave = async () => {
    try {
      // You may use id=1 if your API expects a fixed ID or user-specific id.
      const id = 1;

      await api.get("UpdateOrderTime", {
        id,
        breakfast: mealTimes.breakfast,
        lunch: mealTimes.lunch,
        dinner: mealTimes.dinner,
        other: mealTimes.other,
      });

      alert("✅ Time updated successfully!");
      closeTimePopup();
      await fetchMealTimes(); // Refresh displayed times
    } catch (error) {
      console.error("❌ Error updating time:", error);
      alert("Failed to update time. Check console for details.");
    }
  };

  // 🔹 UI Rendering
  return (
    <div className="min-h-screen bg-gray-50">
      <Header onLogout={handleLogout} />
      <main className="p-2 md:ml-64">
        <div className="px-4 mx-auto mt-1 sm:px-2 lg:px-4 max-w-7xl">
      {/* Header */}
      <div className="flex flex-col items-start justify-between gap-2 p-2 mb-2 bg-white shadow-sm md:flex-row md:items-center rounded-2xl">
        <button
          onClick={handleBack}
          className="inline-flex items-center justify-center w-auto px-3 py-1 font-semibold text-gray-800 transition bg-gray-200 rounded-full shadow-md hover:bg-gray-300"
        >
          ← Back
        </button>

        <h2 className="w-full text-2xl font-bold text-center text-orange-600 sm:text-3xl md:w-auto">
          Menu
        </h2>

        {/* Date Buttons */}
        <div className="flex flex-col items-center w-full gap-2 mt-2 md:items-end md:w-auto md:mt-0">
          <div className="font-semibold text-center text-gray-700 md:text-right">
            Select Date
          </div>
          <div className="flex flex-wrap justify-center gap-2 md:justify-end">
            {[today, tomorrow].map((date) => {
              const dateValue = formatDateForApi(date);
              return (
                <button
                  key={dateValue}
                  onClick={() => setSelectedDate(dateValue)}
                  className={`px-3 py-1 rounded-full text-sm font-semibold transition ${selectedDate === dateValue
                    ? "bg-gradient-to-r from-orange-500 to-orange-600 text-white shadow-md"
                    : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                    }`}
                >
                  {formatDisplayDate(date)}
                </button>
              );
            })}
          </div>
        </div>
      </div>

      {showAreaPopup && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center px-3 bg-black bg-opacity-40"
          onMouseDown={closeAreaPopup}
        >
          <div
            className="flex max-h-[88vh] w-full max-w-3xl flex-col overflow-hidden rounded-xl bg-white shadow-2xl"
            onMouseDown={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between px-5 py-4 text-white bg-orange-500">
              <div>
                <h3 className="text-lg font-bold">No Supply Area Lock</h3>
                <p className="text-sm text-orange-50">
                  Checked areas will not receive {activeCategory || "this item type"} on {areaPopupDate}
                </p>
              </div>
              <button
                onClick={closeAreaPopup}
                className="flex items-center justify-center w-8 h-8 text-sm font-bold bg-orange-600 rounded-full hover:bg-orange-700"
                title="Close"
              >
                X
              </button>
            </div>

            <div className="px-5 py-3 border-b bg-gray-50">
              <div className="grid gap-3 md:grid-cols-[288px_1fr_288px] md:items-end">
                <div className="relative w-full md:w-72">
                  <label className="block mb-1 text-xs font-bold text-gray-500">
                    Area lock list
                  </label>
                  <input
                    type="text"
                    value={selectedAreaLockList}
                    onChange={(e) => {
                      handleAreaLockListChange(e.target.value);
                      setAreaLockDropdownOpen(true);
                    }}
                    onFocus={() => setAreaLockDropdownOpen(true)}
                    onBlur={() => setAreaLockDropdownOpen(false)}
                    placeholder="Type list name..."
                    className="w-full px-3 py-2 text-sm font-semibold text-gray-700 transition bg-white border border-gray-200 rounded-lg outline-none focus:border-orange-300 focus:ring-2 focus:ring-orange-100"
                  />
                  {areaLockDropdownOpen && (
                    <div className="absolute left-0 right-0 z-20 py-1 mt-1 overflow-y-auto bg-white border border-orange-100 rounded-lg shadow-xl max-h-44">
                      {filteredAreaLockLists.length > 0 ? (
                        filteredAreaLockLists.map((list) => (
                          <button
                            key={list.ListName}
                            type="button"
                            onMouseDown={(e) => e.preventDefault()}
                            onClick={() => {
                              handleAreaLockListChange(list.ListName);
                              setAreaLockDropdownOpen(false);
                            }}
                            className={`block w-full px-3 py-2 text-left text-sm font-semibold transition ${
                              selectedAreaLockList === list.ListName
                                ? "bg-orange-50 text-orange-700"
                                : "text-gray-700 hover:bg-orange-50"
                            }`}
                          >
                            {list.ListName}
                          </button>
                        ))
                      ) : (
                        <div className="px-3 py-2 text-sm font-semibold text-gray-500">
                          New list: {selectedAreaLockList.trim()}
                        </div>
                      )}
                    </div>
                  )}
                </div>

                <div className="md:col-start-1 md:col-end-3 md:row-start-2">
                  <div className="mb-2 text-sm font-bold text-gray-700">
                    {activeCategory || "Item Type"} Areas
                  </div>
                  <div className="flex flex-wrap gap-2">
                    {areaCircles.map((circle) => {
                      const circleLockedCount = getCircleLockedCount(circle);
                      return (
                        <button
                          key={circle}
                          onClick={() => {
                            setActiveAreaCircle(circle);
                            setAreaSearchText("");
                          }}
                          className={`inline-flex items-center gap-2 rounded-full px-4 py-1 text-sm font-semibold transition ${
                            activeAreaCircle === circle
                              ? "bg-orange-500 text-white shadow"
                              : "bg-white text-gray-700 hover:bg-orange-100"
                          }`}
                        >
                          {circle}
                          {circleLockedCount > 0 && (
                            <span
                              className={`rounded-full px-2 py-0.5 text-xs font-bold ${
                                activeAreaCircle === circle
                                  ? "bg-white text-orange-600"
                                  : "bg-orange-100 text-orange-700"
                              }`}
                            >
                              {circleLockedCount}
                            </span>
                          )}
                        </button>
                      );
                    })}
                  </div>
                </div>

                <input
                  type="text"
                  value={areaSearchText}
                  onChange={(e) => setAreaSearchText(e.target.value)}
                  placeholder="Search area..."
                  className="w-full px-3 py-2 text-sm font-medium text-gray-700 transition bg-white border border-gray-200 rounded-lg outline-none focus:border-orange-300 focus:ring-2 focus:ring-orange-100 md:col-start-3 md:row-start-1"
                />
              </div>
            </div>

            <div className="flex-1 p-5 overflow-y-auto">
              {areaLoading ? (
                <div className="py-10 font-semibold text-center text-gray-600">
                  Loading areas...
                </div>
              ) : areaCircles.length === 0 ? (
                <div className="py-10 font-semibold text-center text-gray-500">
                  No areas found
                </div>
              ) : (
                <div className="overflow-hidden border border-gray-200 rounded-lg">
                  <label className="flex items-center gap-3 px-4 py-3 font-bold text-gray-700 bg-gray-100 border-b cursor-pointer">
                    <input
                      type="checkbox"
                      checked={allVisibleSelected}
                      onChange={(e) => toggleCircleAreas(e.target.checked)}
                      className="w-4 h-4 accent-orange-500"
                    />
                    Do not supply in {activeAreaCircle}
                    {areaSearchText.trim() && (
                      <span className="text-xs font-semibold text-gray-500">
                        ({filteredAreaRows.length} match)
                      </span>
                    )}
                  </label>

                  <div className="divide-y divide-gray-100">
                    {filteredAreaRows.length > 0 ? (
                      filteredAreaRows.map((area) => (
                        <label
                          key={area.AreaId}
                          className="flex items-center gap-3 px-4 py-2 ml-6 text-sm font-medium text-gray-700 cursor-pointer hover:bg-orange-50"
                        >
                          <input
                            type="checkbox"
                            checked={selectedAreaIdSet.has(String(area.AreaId))}
                            onChange={(e) =>
                              toggleArea(area.AreaId, e.target.checked)
                            }
                            className="w-4 h-4 accent-orange-500"
                          />
                          <span>{area.Area}</span>
                        </label>
                      ))
                    ) : (
                      <div className="px-4 py-8 text-center text-gray-500">
                        No matching areas
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>

            <div className="flex flex-wrap items-center justify-between gap-3 px-5 py-4 border-t bg-gray-50">
              <div className="flex flex-wrap items-center gap-3">
                <span className="text-sm font-semibold text-gray-500">
                  {isRegularAreaLockList
                    ? "Regular list cannot be updated."
                    : "Select areas where supply should be stopped."}
                </span>
                <button
                  onClick={handleDistributionListSave}
                  disabled={
                    !selectedAreaLockList ||
                    isRegularAreaLockList ||
                    selectedAreaIds.length === 0 ||
                    listSaveLoading
                  }
                  className={`rounded-md px-3 py-2 text-sm font-semibold ${
                    !selectedAreaLockList ||
                    isRegularAreaLockList ||
                    selectedAreaIds.length === 0 ||
                    listSaveLoading
                      ? "cursor-not-allowed bg-gray-200 text-gray-400"
                      : "bg-orange-100 text-orange-700 hover:bg-orange-200"
                  }`}
                >
                  {listSaveLoading ? "Saving List..." : "Save List"}
                </button>
              </div>
              <div className="flex gap-3">
                <button
                  onClick={closeAreaPopup}
                  className="px-4 py-2 font-semibold text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300"
                >
                  Cancel
                </button>
                <button
                  onClick={handleAreaSave}
                  disabled={selectedAreaIds.length === 0}
                  className={`rounded-md px-4 py-2 font-semibold text-white ${
                    selectedAreaIds.length === 0
                      ? "cursor-not-allowed bg-gray-300"
                      : "bg-green-500 hover:bg-green-600"
                  }`}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* 🔹 Add Time Update Button */}
      <div className="flex flex-wrap justify-end gap-2 mb-2">
        <button
          onClick={openTimePopup}
          className="inline-flex items-center justify-center px-4 py-2 text-sm font-semibold text-gray-700 transition bg-white border border-gray-200 rounded-full shadow-sm hover:border-orange-200 hover:bg-orange-50 hover:text-orange-700"
        >
          ⏰ Time Update
        </button>
        <button
          onClick={() => openAreaPopup(selectedDate)}
          className="inline-flex items-center justify-center gap-2 px-4 py-2 text-sm font-semibold text-orange-700 transition border border-orange-200 rounded-full shadow-sm bg-orange-50 hover:bg-orange-100 hover:text-orange-800"
          title="Lock areas where food will not be supplied"
        >
          Area Lock
          {(selectedAreaIdsByDate[getAreaLockKey(selectedDate)]?.length || 0) > 0 && (
            <span className="rounded-full bg-orange-500 px-2 py-0.5 text-xs font-bold text-white">
              {selectedAreaIdsByDate[getAreaLockKey(selectedDate)].length}
            </span>
          )}
        </button>
        <div className="relative" ref={previousMenuRef}>
          <button
            onClick={() => setShowPreviousMenuPicker((prev) => !prev)}
            className="inline-flex items-center justify-center gap-2 px-4 py-2 text-sm font-semibold text-white transition bg-orange-500 border border-orange-500 rounded-full shadow-sm hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-300"
            title="Copy menu from a previous date"
          >
            <span className="text-base leading-none">↺</span>
            Menu As
          </button>
          {showPreviousMenuPicker && (
            <div className="absolute right-0 z-20 w-72 overflow-hidden mt-2 bg-white border border-orange-100 shadow-xl rounded-xl">
              <div className="px-4 py-3 bg-orange-50 border-b border-orange-100">
                <div className="text-sm font-bold text-gray-800">Copy Previous Menu</div>
                <div className="mt-1 text-xs font-semibold text-orange-700">
                  Target date: {selectedDate}
                </div>
              </div>
              <div className="p-4">
              <label className="block mb-2 text-xs font-bold tracking-wide text-gray-500 uppercase">
                Source date
              </label>
              <input
                type="date"
                value={previousMenuDate}
                onChange={(e) => handlePreviousMenuDateChange(e.target.value)}
                disabled={previousMenuLoading}
                className="w-full px-3 py-2 text-sm font-semibold text-gray-700 border border-gray-200 rounded-md focus:border-orange-300 focus:outline-none focus:ring-2 focus:ring-orange-200"
              />
              {previousMenuLoading && (
                <div className="mt-3 text-xs font-semibold text-orange-600">
                  Loading menu...
                </div>
              )}
              </div>
            </div>
          )}
        </div>

        {showPreviousMenuPopup && (
          <div
            className="fixed inset-0 z-50 flex items-center justify-center px-3 bg-black bg-opacity-40"
            onMouseDown={closePreviousMenuPopup}
          >
            <div
              className="flex max-h-[86vh] w-full max-w-6xl flex-col overflow-hidden rounded-xl bg-white shadow-2xl"
              onMouseDown={(e) => e.stopPropagation()}
            >
              <div className="flex flex-wrap items-center justify-between gap-4 px-5 py-4 text-white bg-orange-500">
                <div>
                  <h3 className="text-lg font-bold">Copy Previous Menu</h3>
                  <div className="flex flex-wrap gap-2 mt-2 text-xs font-bold">
                    <span className="px-2 py-1 rounded-full bg-white/20">
                      From: {previousMenuDate || "Selected date"}
                    </span>
                    <span className="px-2 py-1 rounded-full bg-white/20">
                      To: {selectedDate}
                    </span>
                    <span className="px-2 py-1 rounded-full bg-white/20">
                      Items: {previousMenuRows.length}
                    </span>
                  </div>
                </div>
                <button
                  onClick={closePreviousMenuPopup}
                  className="flex items-center justify-center w-8 h-8 text-sm font-bold transition bg-orange-600 rounded-full hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-white"
                  title="Close"
                >
                  X
                </button>
              </div>

              <div className="overflow-auto">
                <table className="min-w-full text-sm bg-white">
                  <thead className="sticky top-0 text-white bg-gradient-to-r from-orange-500 to-orange-600">
                    <tr>
                      <th className="px-4 py-3 text-left">Item Code</th>
                      <th className="px-4 py-3 text-left">Item Name</th>
                      <th className="px-4 py-3 text-left">Type</th>
                      <th className="px-4 py-3 text-right">MRP</th>
                      <th className="px-4 py-3 text-right">Circle1</th>
                      <th className="px-4 py-3 text-right">Circle2</th>
                      <th className="px-4 py-3 text-right">Circle3</th>
                      <th className="px-4 py-3 text-right">Take Away</th>
                      <th className="px-4 py-3 text-left">Menu Date</th>
                      <th className="px-4 py-3 text-left">Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    {previousMenuRows.length > 0 ? (
                      previousMenuRows.map((item, index) => (
                        <tr
                          key={`${item.ItemId || item.Item_No || "item"}_${index}`}
                          className="text-gray-700 border-b hover:bg-gray-50"
                        >
                          <td className="px-4 py-3 font-mono">{item.Item_No}</td>
                          <td className="px-4 py-3 font-semibold">{item.Item_Desc1}</td>
                          <td className="px-4 py-3">{item.Item_Type}</td>
                          <td className="px-4 py-3 text-right">{Number(item.MRP || 0)}</td>
                          <td className="px-4 py-3 text-right">{Number(item.Circle1Rate || 0)}</td>
                          <td className="px-4 py-3 text-right">{Number(item.Circle2Rate || 0)}</td>
                          <td className="px-4 py-3 text-right">{Number(item.Circle3Rate || 0)}</td>
                          <td className="px-4 py-3 text-right">{Number(item.TakeAway || 0)}</td>
                          <td className="px-4 py-3">
                            {item.Menudate?.split("T")[0] || previousMenuDate}
                          </td>
                          <td className="px-4 py-3 min-w-64">
                            {item.Item_Desc2 && item.Item_Desc2 !== "''"
                              ? item.Item_Desc2
                              : ""}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={10} className="px-4 py-8 text-center text-gray-500">
                          No previous menu items found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <div className="flex flex-wrap items-center justify-between gap-3 px-5 py-4 border-t bg-gray-50">
                <div className="text-sm font-semibold text-gray-600">
                  This will replace the menu for {selectedDate}.
                </div>
                <div className="flex items-center justify-end gap-3">
                <button
                  onClick={closePreviousMenuPopup}
                  className="px-4 py-2 text-sm font-semibold text-gray-700 transition bg-white border border-gray-200 rounded-md hover:bg-gray-100"
                >
                  Cancel
                </button>
                <button
                  onClick={handleInsertPreviousMenu}
                  disabled={previousMenuInsertLoading || previousMenuRows.length === 0}
                  className={`px-4 py-2 text-sm font-semibold text-white transition rounded-md shadow-sm ${
                    previousMenuInsertLoading || previousMenuRows.length === 0
                      ? "cursor-not-allowed bg-orange-300"
                      : "bg-orange-500 hover:bg-orange-600"
                  }`}
                >
                  {previousMenuInsertLoading ? "Inserting..." : "Insert to Current Date"}
                </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* ✅ Popup Modal for Time Update */}
        {showTimePopup && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
            <div className="p-4 bg-white shadow-lg rounded-2xl w-96">
              <h3 className="mb-2 text-lg font-bold text-center text-gray-800">
                Update Meal Times
              </h3>

              <div className="flex flex-col gap-3">
                <div>
                  <label className="block mb-1 font-medium text-gray-700">
                    Breakfast
                  </label>
                  <input
                    type="time"
                    value={mealTimes.breakfast}
                    onChange={(e) =>
                      handleTimeChange("breakfast", e.target.value)
                    }
                    className="w-full px-3 py-2 border rounded-md focus:ring-2 focus:ring-orange-300"
                  />
                </div>

                <div>
                  <label className="block mb-1 font-medium text-gray-700">
                    Lunch
                  </label>
                  <input
                    type="time"
                    value={mealTimes.lunch}
                    onChange={(e) =>
                      handleTimeChange("lunch", e.target.value)
                    }
                    className="w-full px-3 py-2 border rounded-md focus:ring-2 focus:ring-orange-300"
                  />
                </div>

                <div>
                  <label className="block mb-1 font-medium text-gray-700">
                    Dinner
                  </label>
                  <input
                    type="time"
                    value={mealTimes.dinner}
                    onChange={(e) =>
                      handleTimeChange("dinner", e.target.value)
                    }
                    className="w-full px-3 py-2 border rounded-md focus:ring-2 focus:ring-orange-300"
                  />
                </div>
                <div>
                  <label className="block mb-1 font-medium text-gray-700">Others</label>
                  <input
                    type="time"
                    value={mealTimes.other || ""}
                    onChange={(e) => handleTimeChange("other", e.target.value)}
                    className="w-full px-3 py-2 border rounded-md focus:ring-2 focus:ring-orange-300"
                  />
                </div>

              </div>

              <div className="flex justify-end gap-3 mt-6">
                <button
                  onClick={handleTimeSave}
                  className="px-3 py-1 font-semibold text-white bg-orange-500 rounded-md hover:bg-orange-600"
                >
                  Save
                </button>

                <button
                  onClick={closeTimePopup}
                  className="px-3 py-1 font-semibold text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* 🔸 Category Buttons */}
      {categories.length > 0 && (
        <div className="flex flex-wrap justify-center gap-2 mt-6 mb-1">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveCategory(cat)}
              className={`px-4 py-1 rounded-full text-sm font-semibold transition mt-0 ${activeCategory === cat
                ? "bg-orange-500 text-white shadow-md "
                : "bg-gray-100 text-gray-800 hover:bg-orange-100"
                }`}
            >
              {cat}
            </button>
          ))}
        </div>
      )}

      {/* 🔹 Searchable Dropdown */}
      <div className="flex flex-col items-start max-w-4xl gap-4 p-4 mx-auto bg-white shadow-lg sm:flex-row sm:items-end sm:p-6 rounded-2xl">
        <div className="relative flex-1 w-full sm:w-auto" ref={dropdownRef}>
          <label className="block mb-1 font-semibold text-gray-700">
            Item Name
          </label>
          <input
            type="text"
            value={searchText}
            onChange={(e) => {
              setSearchText(e.target.value);
              setDropdownOpen(true);
              setActiveIndex(-1);
            }}
            onClick={() => setDropdownOpen(!dropdownOpen)}
            onKeyDown={handleKeyDownItem}
            placeholder="Search by item name or code..."
            className="w-full px-4 py-2 border rounded-md cursor-pointer focus:ring-2 focus:ring-orange-300"
          />
          {dropdownOpen && (
            <ul ref={listRef} className="absolute z-10 w-full mt-1 overflow-y-auto bg-white border rounded-md shadow-lg max-h-60">
              {filteredItems?.length > 0 ? (
                filteredItems.map((item, index) => (
                  <li
                    key={item.Item_No}
                    onClick={() => {
                      setSelectedItem(item);
                      setSearchText(item.Item_Desc1);
                      setDropdownOpen(false);
                      setActiveIndex(-1);
                    }}
                    onMouseEnter={() => setActiveIndex(index)}
                    className={`px-4 py-2 cursor-pointer ${
                      index === activeIndex
                        ? "bg-gray-100 font-semibold"
                        : "hover:bg-orange-100"
                    }`}
                  >
                    {item.Item_Desc1}
                  </li>
                ))
              ) : (
                <li className="px-4 py-2 text-gray-500">No items found</li>
              )}
            </ul>
          )}
        </div>

        <div className="flex-1 w-full sm:w-auto">
          <label className="block mb-1 font-semibold text-gray-700">
            Description
          </label>
          <input
            type="text"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Enter description…"
            className="w-full px-4 py-2 border rounded-md focus:ring-2 focus:ring-orange-300"
          />
        </div>

        <button
          onClick={handleAddItem}
          className="px-4 py-1 font-semibold text-white transition bg-orange-500 rounded-full shadow-md sm:w-auto hover:bg-orange-600"
        >
          Add
        </button>
      </div>

      {/* 🔹 Combined Table */}
      {(selectedItems.length > 0 || table1Items.length > 0) && (
        <div className="max-w-full mx-auto mb-6 overflow-x-auto shadow-lg rounded-2xl">
          <h3 className="flex items-center justify-between px-4 py-3 text-lg font-bold text-gray-700 bg-gray-100 rounded-t-2xl">
  Menu Items

  <label className="flex items-center gap-2 text-sm font-bold text-gray-700">
    <input
      type="checkbox"
      checked={rateEdit}
      onChange={() => setRateEdit(!rateEdit)}
      className="w-4 h-4 cursor-pointer"
    />
    Rate Edit
  </label>
</h3>

          <table className="min-w-full text-sm bg-white rounded-b-2xl">
            <thead>
              <tr className="text-white bg-gradient-to-r from-orange-500 to-orange-600">
                <th className="px-4 py-3 text-left">Item Code</th>
                <th className="px-4 py-3 text-left">Item Name</th>
                <th className="px-4 py-3 text-left">Description</th>
                {circles.map((circle) => (
                  <th key={circle} className="px-4 py-3 text-left">
                    {circle} Rate
                  </th>
                ))}
                <th className="px-4 py-3 text-left">Take Away</th>
                <th className="px-4 py-3 text-left">Action</th>
                <th className="px-4 py-3 text-left">Attachments</th>
              </tr>
            </thead>
            <tbody>
              {displayItems.map((item, index) => (
                <tr
                  key={index}
                  className="text-gray-700 border-b hover:bg-gray-50"
                >
                  <td className="px-4 py-3 font-mono">
                    {item.code || item.Item_No}
                  </td>
                  <td className="px-4 py-3 font-semibold">
                    {item.name || item.Item_Desc1}
                  </td>

                  <td className="px-4 py-3 font-semibold">
                    <textarea
                      value={item.Item_Desc2 || ""}
                      onChange={(e) =>
                        handleDescriptionChange(item.sourceIndex, e.target.value, item.source)
                      }
                      placeholder="Enter description…"
                      rows={2}
                      className="w-56 px-2 py-1 border rounded-md resize-y focus:ring-2 focus:ring-orange-300"
                    />
                  </td>

                  {item.rates?.map((rate, idx) => (
                    <td key={idx} className="px-2 py-1 sm:px-4">
   <input
  type="number"
  value={rate ?? 0}
  disabled={!rateEdit}
   onWheel={(e) => e.preventDefault()}
  onChange={(e) =>
    handleRateChange(item.sourceIndex, idx, e.target.value, item.source)
  }
  onFocus={handleFocusAddWheelBlock}
  onBlur={handleBlurRemoveWheelBlock}
  className="w-20 px-2 py-1 text-right border rounded-md focus:ring-2 focus:ring-orange-300"
/>

                    </td>
                  ))}

                  <td className="px-2 py-1 sm:px-4">
                    <input
                      type="number"
                      value={item.TakeAway ?? 0}
                      disabled={!rateEdit}
                      onWheel={(e) => e.preventDefault()}
                      onChange={(e) =>
                        handleTakeAwayChange(item.sourceIndex, e.target.value, item.source)
                      }
                      onFocus={handleFocusAddWheelBlock}
                      onBlur={handleBlurRemoveWheelBlock}
                      className="w-20 px-2 py-1 text-right border rounded-md focus:ring-2 focus:ring-orange-300"
                    />
                  </td>

                  <td className="flex flex-col gap-2 px-4 py-3 sm:flex-row">
                    <button
                      onClick={() =>
                        handleRowUpdate(item.sourceIndex, item.source)
                      }
                      className="px-2 py-1 text-white transition bg-green-500 rounded-md shadow-sm hover:bg-green-600"
                    >
                      Update
                    </button>
                    <button
                      onClick={() => handleDelete(item.sourceIndex, item.source)}
                      className="px-2 py-1 text-white transition bg-red-500 rounded-md shadow-sm hover:bg-red-600"
                    >
                      Delete
                    </button>
                  </td>
                  <td className="px-4 py-3 font-mono">
                    <Attachments
                      mdlId="Item_Master"
                      primeId={item.ItemId}
                      primeName={item.Item_Desc1}
                      uploadedBy={localStorage.getItem("username") || "UnknownUser"}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
        </div>
      </main>
    </div>
  );
}
